import { useState } from "react";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { createCheckout } from "@/lib/api";

const LABELS = {
  clarity: "Begin Personal Clarity — £499",
  clarity_balance: "Complete the year — £2,501",
  monthly: "Pay monthly — £300",
};

export const DepositButton = ({ email = "", assessmentId = null, plan = "clarity", testId = "clarity-button" }) => {
  const [busy, setBusy] = useState(false);
  const label = LABELS[plan] || LABELS.clarity;

  const go = async () => {
    setBusy(true);
    try {
      const res = await createCheckout({
        origin_url: window.location.origin,
        plan,
        email: email || null,
        assessment_id: assessmentId,
      });
      window.location.href = res.checkout_url;
    } catch {
      toast.error("Could not start the secure checkout — please try again.");
      setBusy(false);
    }
  };

  return (
    <button
      onClick={go}
      disabled={busy}
      data-testid={testId}
      className="inline-flex items-center justify-center gap-2 bg-weave-ink text-white hover:bg-weave-ink/90 transition-colors duration-300 rounded-full px-6 py-3 text-sm font-medium disabled:opacity-60"
    >
      {busy ? <Loader2 size={16} className="animate-spin" /> : <Lock size={14} />}
      {label}
    </button>
  );
};
